module.exports = __webpack_public_path__ + "img/PAI_LISTE_A_GAUCHE_DU_NOM.cb89d800.svg";